<template>
  <div></div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  window.location.href = '/';
});
</script>

<style scoped></style>
